import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AddressPipe } from '@lockton-apps/shared/ui/lui';

import { ProposalLocalFacade } from './+state/proposal-local.facade';
import { ProposalLocalStore } from './+state/proposal-local.store';
import * as fromProposals from './+state/proposals.reducer';
import * as fromProposalConfig from './+state/proposal-config/proposal-config.reducer';
import { AccaDynamicFormsExtensionsService } from './services/acca/acca-dynamic-forms-extensions.service';
import { LsosApplicationHooksService } from './services/lsos/lsos-application-hooks.service';
import { LsosDynamicFormsExtensionsService } from './services/lsos/lsos-dynamic-forms-extensions.service';
import { NorwayDynamicFormsExtensionsService } from './services/norway/norway-dynamic-forms-extensions.service';
import { ProposalsStepCustomizerService } from './services/proposals-step-customizer.service';
import { SharedProposalsEffects } from './+state/proposals.effects';
import { NorwayApplicationHooksService } from './services/norway/norway-application-hooks.service';
import { PncDynamicFormsExtensionsService } from './services/pnc/pnc-dynamic-forms-extensions.service';
import { ProposalConfigEffects } from './+state/proposal-config/proposal-config.effects';
import { ConstructionDynamicFormsExtensionsService } from './services/construction/construction-dynamic-forms-extensions.service';
import { ConstructionApplicationHooksService } from './services/construction/construction-application-hooks.service';
import { EnwDynamicFormsExtensionsService } from './services/enw/enw-dynamic-forms-extensions.service';
import { EnwApplicationHooksService } from './services/enw/enw-application-hooks.service';
import { DefaultDynamicFormsExtensionsService } from './routed-portal-extensions.factory';
import { RegulatoryApplicationHooksService } from './services/regulatory/regulatory-application-hooks.service';
import { RegulatoryDynamicFormsExtensionsService } from './services/regulatory/regulatory-dynamic-forms-extensions.service';
import { AccaOverDynamicFormsExtensionsService } from './services/acca-over/acca-over-dynamic-forms-extensions.service';
import { LsosDynamicFormsExtensionsDeprecatedService } from './services/lsos/lsos-dynamic-forms-extensions-deprecated.service';
import { Currency2Pipe } from '@lockton-apps/shared/ui/pipes';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromProposals.SHARED_PROPOSALS_FEATURE_KEY,
      fromProposals.sharedProposalsReducer
    ),
    StoreModule.forFeature(
      fromProposalConfig.PROPOSAL_CONFIG_FEATURE_KEY,
      fromProposalConfig.sharedProposalsReducer
    ),
    EffectsModule.forFeature([SharedProposalsEffects, ProposalConfigEffects]),
  ],
  providers: [
    ProposalsStepCustomizerService,
    ProposalLocalFacade,
    ProposalLocalStore,
    AddressPipe,
    DecimalPipe,
    Currency2Pipe,
  ],
})
export class SharedDataAccessProposalsModule {}

export function provideHooksAndExtensions() {
  return [
    DefaultDynamicFormsExtensionsService,

    LsosApplicationHooksService,
    LsosDynamicFormsExtensionsService,
    LsosDynamicFormsExtensionsDeprecatedService,

    NorwayApplicationHooksService,
    NorwayDynamicFormsExtensionsService,

    AccaDynamicFormsExtensionsService,

    AccaOverDynamicFormsExtensionsService,

    PncDynamicFormsExtensionsService,

    ConstructionDynamicFormsExtensionsService,
    ConstructionApplicationHooksService,

    EnwDynamicFormsExtensionsService,
    EnwApplicationHooksService,

    RegulatoryDynamicFormsExtensionsService,
    RegulatoryApplicationHooksService,
  ];
}
